import { useState } from "react";
import chevronDown from "./imgs/chevron-down.svg";
import chevronUp from "./imgs/chevron-up.svg";

const FaqItem = ({ category, hideForF1, questions, isLast, eventName }) => {
  const [isOpen, setIsOpen] = useState(false);

  const parseAnswerParagraphs = (answer) => {
    // if \n is present, split the answer into paragraphs else return the answer wrapped in a p tag
    return answer.includes("\n") ? (
      answer.split("\n").map((line, i) => <p key={i}>{line}</p>)
    ) : (
      <p>{answer}</p>
    );
  };

  if (eventName === "F1" && hideForF1) {
    return null;
  }

  return (
    <div className="faq-container">
      <div className={`faq-item ${isLast ? "faq-no-border" : ""}`}>
        <p>
          <span className="bold">{`${category} `}</span>
        </p>
        <img
          src={isOpen ? chevronUp : chevronDown}
          alt="chevron-down"
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      {isOpen &&
        questions.map(({ question, answer }, index) => (
          <div key={index}>
            <p className="bold">{question}</p>
            <div className="answer-container">
              {parseAnswerParagraphs(answer)}
            </div>
          </div>
        ))}
    </div>
  );
};

export default FaqItem;
